import React from 'react'
import styled from 'styled-components'

import { fonts, palette } from '../../styles/variables'
import { getOS } from '../../utils/functions'
import { Text } from '../topography'

const FieldInputWrapper = styled.div((props) => ({
  background: 'none',
  position: 'relative',
  ...(props.styles || {}),
}))

const Textarea = styled.textarea(
  ({
    width = '100%',
    height = 40,
    backgroundColor = palette.white,
    borderColor = palette.lightGray,
    placeholderColor = palette.gray,
    focusedBorderColor,
  }) => ({
    height,
    width,
    padding: '16px',
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: fonts.primary,
    backgroundColor: `${backgroundColor} !important`,
    outline: 'none',
    borderRadius: '2px',
    WebkitAppearance: 'none',
    border: `1px solid ${borderColor}`,
    '::placeholder': {
      color: placeholderColor,
      fontWeight: getOS() === 'Mac' ? 900 : '400',
    },
    ':focus': {
      borderColor: focusedBorderColor || borderColor,
    },
  }),
)

export const UberTextarea = ({
  value,
  onChange,
  styles,
  inputRef,
  invalidMessage,
  ...rest
}) => {
  return (
    <FieldInputWrapper styles={styles}>
      <Textarea
        value={value}
        onChange={onChange}
        ref={inputRef}
        borderColor={invalidMessage ? palette.danger : palette.lightGray}
        {...rest}
      />
      {invalidMessage && (
        <Text
          fontSize="12px"
          lineHeight="12px"
          color={palette.danger}
          margin="8px 0 0 0"
        >
          {invalidMessage}
        </Text>
      )}
    </FieldInputWrapper>
  )
}
